module.exports = __webpack_public_path__ + "static/media/Romantic-Couple-Script.0082a9af.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Romantic-Couple-Script.eot
// module id = 2208
// module chunks = 50